import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import theme from '@styles/theme';

const FaqListRow = ({ data }: any) => {
    const navigate = useNavigate();
    return (
        <TableRow onClick={() => navigate(`/faq/${data?.id}`)}>
            <Category>{data.category || '-'}</Category>
            <Title>{data.title || '-'}</Title>
        </TableRow>
    );
};

export default FaqListRow;

const TableRow = styled.li`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 12px 0;
    transition: all 0.25s;
    cursor: pointer;
    &:hover {
        background-color: ${theme.colors.lightGrayHoverColor};
    }
`;
const Category = styled.span`
    display: inline-block;
    margin: 0 0 12px;
    font-size: 14px;
    color: ${theme.colors.deepGrayFontColor};
    line-height: 16px;
`;
const Title = styled.div`
    font-size: 16px;
    font-family: PretendardMedium, sans-serif;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1.25;
`;
